import React from 'react';
import styled from 'astroturf/react';

import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import { ImpressionEntity } from 'js/utils/impressions/watchImpressions';
import { CourseCard, CourseCardProps } from '../shared/Carousel';

export interface Props {
  id: string;
  name: string;
  courses: Array<CourseCardProps>;
}

const Title = styled.h2`
  margin-top: 40px;
  margin-bottom: 16px;
  font-weight: normal;
  font-size: 26px;
  line-height: 32px;
  color: #121212;

  @media screen and (max-width: 767px) {
    font-size: 20px;
    line-height: 18px;
  }
`;

const CoursesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 56px;

  @media screen and (max-width: 767px) {
    display: flex;
    overflow-x: auto;
    margin: -16px -16px 22px;
    padding: 16px;
  }

  @media screen and (max-width: 991px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const Container = styled(ImpressionWatcher)`
  flex: 0 0 232px;
  filter: drop-shadow(0px 3px 16px rgba(0, 0, 0, 0.1));
`;

const SubtopicSection: React.FunctionComponent<Props> = ({
  id,
  name,
  courses,
}) => {
  const items = courses.map((course, index) => (
    <Container
      source={'topic-marketing-page'}
      entity_type={ImpressionEntity.Course}
      entity_id={course.courseId}
      extra={{
        position: index,
        subtopicId: id,
        ...course.impressionData,
      }}
      threshold={0.4}
    >
      <CourseCard
        key={course.courseId}
        courseId={course.courseId}
        thumbnailPath={course.thumbnailPath}
        title={course.title}
        numVideos={course.numVideos}
        duration={course.duration}
        instructorName={course.instructorName}
        isNew={course.isNew}
      />
    </Container>
  ));

  return (
    <>
      <Title id={id}>{name}</Title>
      <CoursesContainer>{items}</CoursesContainer>
    </>
  );
};

export default SubtopicSection;
